<template>
	<dl class="buyCountInfo sort-item"
		v-if="ptInitData.productInfo.HANBAI_FLG == 1 && !(ptInitData.siteKbn == '4' && !ptInitData.loginKbn) && !doChkCartAddTxt">
		<!-- 数量 -->
		<span hidden id="buyCount_lbl">{{ $t('common.labels.quantity') }}</span>
		<dt v-if="ptInitData.puldownFlg != 3">{{ $t('common.labels.quantity') }}</dt>
		<!--テキスト-->
		<dd v-if="ptInitData.puldownFlg == 0">
			<input-check type="text" :maxlength="5" class="buyCount num" v-model="pt125ReqModel.buyCount"
				:name="'buyCount'" id="buyCount" style="width: 85px !important;"
				@on-change="getAnimalQty(pt125ReqModel.buyCount, ptInitData.qtyMin)" />
		</dd>
		<!--プルダウン-->
		<dd v-else-if="ptInitData.puldownFlg == 1">
			<select class="productSelect" :value="value" :name="'buyCount'" @change="handleSelectChange">
				<option v-for="qty in ptInitData.qtyList" :key="qty.KEY" :value="qty.KEY">{{ qty.VALUE }}</option>
			</select>
		</dd>
		<!--＋ーボタン＆テキストボックス（入力もクリック増減も可）-->
		<dd v-else-if="ptInitData.puldownFlg == 2">
			<label class="numberSpinnerWrap">
				<input-check type="text" :maxlength="5" class="buyCount num" v-model="pt125ReqModel.buyCount"
					:name="'buyCount'" id="buyCount" />
				<span class="spinner spinnerDown" v-on:click="stepDown">－</span>
				<span class="spinner spinnerUp" v-on:click="stepUp">＋</span>
			</label>
		</dd>
		<!--表示しない（数量1固定）-->
		<dd v-else-if="ptInitData.puldownFlg == 3">
			<input-check type="text" :maxlength="5" class="buyCount num" v-model="pt125ReqModel.buyCount" :value="1"
				:name="'buyCount'" id="buyCount" hidden />
		</dd>
	</dl>
</template>
<script>
import InputCheck from "components/InputCheck.vue";
export default {
	components: {
		InputCheck
	},
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		pt125ReqModel: {
			type: Object,
			default: null
		},
		value: {
			type: [String, Number],
			default: ''
		},
		doChkCartAddTxt:{
			type: Boolean
		}
	},
	methods: {
		stepDown: function () {
			this.$emit('stepDown')
		},
		stepUp: function () {
			this.$emit('stepUp')
		},
		getAnimalQty: function (buyCount,qtyMin) {
			this.$emit('getAnimalQty',buyCount,qtyMin)
		},
		handleSelectChange(e) {
			const newValue = e.target.value;
			// エミットするイベント名は必ず input としてください（固定値）
			this.$emit('input', newValue);
		}
	}
}
</script>